// Dual-handle price range slider for Horizon's price-facet-component.
// Syncs two <input type="range"> elements with the existing min/max text inputs
// and lets the native on:change bubbling trigger the filter update.

function setupPriceSlider(priceFacet) {
  if (priceFacet.dataset.tjbcSlider) return;
  priceFacet.dataset.tjbcSlider = '1';

  const wrapper = priceFacet.querySelector('.tjbc-price-slider-wrapper');
  if (!wrapper) return;

  const minSlider = wrapper.querySelector('.tjbc-price-slider-min');
  const maxSlider = wrapper.querySelector('.tjbc-price-slider-max');
  const minInput = priceFacet.querySelector('[ref="minInput"]');
  const maxInput = priceFacet.querySelector('[ref="maxInput"]');
  const rangeEl = wrapper.querySelector('.tjbc-price-slider-range');

  if (!minSlider || !maxSlider || !minInput || !maxInput) return;

  const rangeMax = parseFloat(wrapper.dataset.rangeMax || maxSlider.max);

  function updateTrack() {
    const minPct = (parseFloat(minSlider.value) / rangeMax) * 100;
    const maxPct = (parseFloat(maxSlider.value) / rangeMax) * 100;
    if (rangeEl) {
      rangeEl.style.left = minPct + '%';
      rangeEl.style.right = (100 - maxPct) + '%';
    }
    // When max is near the right edge, promote min slider so its thumb remains grabbable
    minSlider.style.zIndex = parseFloat(maxSlider.value) >= rangeMax * 0.98 ? '4' : '';
  }

  minSlider.addEventListener('input', () => {
    if (parseFloat(minSlider.value) >= parseFloat(maxSlider.value)) {
      minSlider.value = String(Math.max(parseFloat(maxSlider.value) - 1, 0));
    }
    minInput.value = parseFloat(minSlider.value) <= 0 ? '' : minSlider.value;
    updateTrack();
  });

  maxSlider.addEventListener('input', () => {
    if (parseFloat(maxSlider.value) <= parseFloat(minSlider.value)) {
      maxSlider.value = String(Math.min(parseFloat(minSlider.value) + 1, rangeMax));
    }
    maxInput.value = parseFloat(maxSlider.value) >= rangeMax ? '' : maxSlider.value;
    updateTrack();
  });

  // The 'change' event from each slider naturally bubbles up to price-facet-component,
  // where on:change="/updatePriceFilterAndResults" handles the filter update automatically.

  updateTrack();
}

function initAllPriceSliders() {
  document.querySelectorAll('price-facet-component').forEach(setupPriceSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllPriceSliders);
} else {
  initAllPriceSliders();
}

// Re-initialize after Horizon re-renders sections (filter drawer, AJAX updates)
const sliderObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.tagName === 'PRICE-FACET-COMPONENT') {
        setupPriceSlider(node);
      } else {
        node.querySelectorAll('price-facet-component').forEach(setupPriceSlider);
      }
    }
  }
});

sliderObserver.observe(document.documentElement, { childList: true, subtree: true });
